import { t } from "@/i18n-js/instance";

import { LineItem } from "./LineItem";

interface DiscountCouponProps {
  discountCoupon: string;
}

export const DiscountCoupon = ({ discountCoupon }: DiscountCouponProps) => (
  <LineItem
    description={t("pricing_plans.plan_settings.plan_summary.discount_coupon")}
    value={discountCoupon}
    valueProps={{ color: "text-green-success" }}
  />
);
